/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Result of ``POST /docs/classify`` — a suggested extractable doc type.
 * 
 * ``doc_type`` is one of the extractable types (purchase_contract,
 * contract_amendment, listing_agreement, final_settlement_statement) or null
 * when the file matches none of them.
 * @export
 * @interface DocClassificationResponse
 */
export interface DocClassificationResponse {
    /**
     * 
     * @type {string}
     * @memberof DocClassificationResponse
     */
    docType?: string;
    /**
     * 
     * @type {number}
     * @memberof DocClassificationResponse
     */
    confidence: number;
    /**
     * 
     * @type {string}
     * @memberof DocClassificationResponse
     */
    reasoning: string;
}

/**
 * Check if a given object implements the DocClassificationResponse interface.
 */
export function instanceOfDocClassificationResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "confidence" in value;
    isInstance = isInstance && "reasoning" in value;

    return isInstance;
}

export function DocClassificationResponseFromJSON(json: any): DocClassificationResponse {
    return DocClassificationResponseFromJSONTyped(json, false);
}

export function DocClassificationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocClassificationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'docType': !exists(json, 'doc_type') ? undefined : json['doc_type'],
        'confidence': json['confidence'],
        'reasoning': json['reasoning'],
    };
}

export function DocClassificationResponseToJSON(value?: DocClassificationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'doc_type': value.docType,
        'confidence': value.confidence,
        'reasoning': value.reasoning,
    };
}

